import { DefaultPaginatedResponse } from '../clients/admin';

export const mergeResponsesData = <Item>(
  responsesArray: DefaultPaginatedResponse<Item>[]
): Item[] => {
  const resultsArray: Item[][] = responsesArray.map(
    (response: DefaultPaginatedResponse<Item>) => response.results
  );
  return resultsArray.flat();
};
